
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';
import Input from '../../../components/base/Input';
import TopNavigation from '../../../components/feature/TopNavigation';

export default function LoginPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    phone: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setLoading(false);
      navigate('/otp');
    }, 1500);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <TopNavigation 
        title="تسجيل الدخول"
        showBack={true}
      />
      
      <div className="pt-16 px-6 py-8">
        <div className="max-w-sm mx-auto">
          {/* App Logo */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-purple-600 to-pink-600 rounded-full flex items-center justify-center mb-4 mx-auto">
              <i className="ri-car-line text-3xl text-white w-10 h-10 flex items-center justify-center"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: '"Pacifico", serif' }}>
              سامي عبدالسلام
            </h1>
            <p className="text-gray-600">
              مرحباً بك مرة أخرى
            </p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="رقم الجوال"
              type="tel"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              placeholder="05xxxxxxxx"
              icon={<i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <Input
              label="كلمة المرور"
              type="password"
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              placeholder="أدخل كلمة المرور"
              icon={<i className="ri-lock-line w-5 h-5 flex items-center justify-center"></i>}
              required
            />

            <div className="text-left">
              <button
                type="button"
                className="text-purple-600 text-sm hover:text-purple-700"
              >
                نسيت كلمة المرور؟
              </button>
            </div>

            <Button
              type="submit"
              className="w-full"
              size="lg"
              loading={loading}
            >
              تسجيل الدخول
            </Button>
          </form>

          {/* Register Link */}
          <div className="mt-6 text-center">
            <p className="text-gray-600">
              ليس لديك حساب؟{' '}
              <button
                onClick={() => navigate('/register')}
                className="text-purple-600 font-medium hover:text-purple-700"
              >
                أنشئ حساباً جديداً
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
